import React from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "../ui/sheet";
import { formatOfferEndDate } from "../../lib/offers/offerTheme";

// Bottom sheet with the offer's terms and when it ends.
const OfferTermsSheet = ({ open, onOpenChange, offerName, termsText, endAt }) => {
  const endText = formatOfferEndDate(endAt);

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" className="mx-auto max-h-[80vh] max-w-2xl overflow-y-auto rounded-t-2xl bg-white">
        <SheetHeader>
          <SheetTitle className="pr-8 text-gray-900">Offer T&amp;C</SheetTitle>
          <SheetDescription className="text-gray-600">{offerName}</SheetDescription>
        </SheetHeader>
        {endText && (
          <p className="mt-4 text-sm font-semibold text-gray-900">Offer ends {endText}</p>
        )}
        <p className="mt-3 whitespace-pre-line text-sm leading-relaxed text-gray-700">
          {termsText || "Bonus months are added automatically to eligible plan purchases made before the offer ends."}
        </p>
      </SheetContent>
    </Sheet>
  );
};

export default OfferTermsSheet;
